import React from "react";
import { AuthProvider } from "./contexts/AuthContext";
import HockeyLineupBuilder from "./components/HockeyLineupBuilder";

function App() {
  return (
    <AuthProvider>
      <HockeyLineupBuilder />
    </AuthProvider>
  );
}

export default App;
